// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Relude_Map = require("relude/src/Relude_Map.bs.js");
var Relude_Set = require("relude/src/Relude_Set.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_List = require("relude/src/Relude_List.bs.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Relude_Function = require("relude/src/Relude_Function.bs.js");
var Relude_Extensions_Ord = require("relude/src/extensions/Relude_Extensions_Ord.bs.js");

function MakeCustomOpaqueStringType(O) {
  var fromString = O.fromString;
  var toString = O.toString;
  var decode = Curry._1(Json.Decode.variantFromString, fromString);
  var encode = function (param) {
    return Relude_Globals.$great$great(toString, (function (prim) {
                  return prim;
                }), param);
  };
  var compare = Curry._1(Relude_String.compareWithConversion, toString);
  var eq = Curry._1(Relude_String.eqWithConversion, toString);
  var $$Set = Relude_Set.WithOrd({
        eq: eq,
        compare: compare
      });
  var $$Map = Relude_Map.WithOrd({
        eq: eq,
        compare: compare
      });
  return {
          fromString: fromString,
          toString: toString,
          decode: decode,
          encode: encode,
          compare: compare,
          eq: eq,
          Ord: {
            eq: eq,
            compare: compare
          },
          $$Set: $$Set,
          $$Map: $$Map
        };
}

function MakeOpaqueStringType($star) {
  var fromString = function (param) {
    return Relude_Globals.$great$great(Relude_Globals.id, Relude_Option.pure, param);
  };
  var decode = Curry._1(Json.Decode.variantFromString, fromString);
  var encode = function (param) {
    return Relude_Globals.$great$great(Relude_Globals.id, (function (prim) {
                  return prim;
                }), param);
  };
  var compare = Curry._1(Relude_String.compareWithConversion, Relude_Globals.id);
  var eq = Curry._1(Relude_String.eqWithConversion, Relude_Globals.id);
  var $$Set = Relude_Set.WithOrd({
        eq: eq,
        compare: compare
      });
  var $$Map = Relude_Map.WithOrd({
        eq: eq,
        compare: compare
      });
  return {
          fromString: fromString,
          toString: Relude_Globals.id,
          decode: decode,
          encode: encode,
          compare: compare,
          eq: eq,
          Ord: {
            eq: eq,
            compare: compare
          },
          $$Set: $$Set,
          $$Map: $$Map
        };
}

function MakeCustomOpaqueIntType(O) {
  var fromInt = O.fromInt;
  var partial_arg = Curry._1(Relude_Option.flatMap, fromInt);
  var fromString = function (param) {
    return Relude_Globals.$great$great(Relude_String.toInt, partial_arg, param);
  };
  var toInt = O.toInt;
  var toString = function (param) {
    return Relude_Globals.$great$great(toInt, Relude_Int.toString, param);
  };
  var decode = function (json) {
    return Curry._2(Json.Decode.$less$pipe$great, Curry._2(Json.Decode.variantFromInt, fromInt, json), Curry._2(Json.Decode.variantFromString, fromString, json));
  };
  var encode = function (param) {
    return Relude_Globals.$great$great(toInt, (function (prim) {
                  return prim;
                }), param);
  };
  var compare = Curry._1(Relude_Int.compareWithConversion, toInt);
  var eq = Curry._1(Relude_Int.eqWithConversion, toInt);
  var $$Set = Relude_Set.WithOrd({
        eq: eq,
        compare: compare
      });
  var $$Map = Relude_Map.WithOrd({
        eq: eq,
        compare: compare
      });
  return {
          fromInt: fromInt,
          fromString: fromString,
          toInt: toInt,
          toString: toString,
          decode: decode,
          encode: encode,
          compare: compare,
          eq: eq,
          Ord: {
            eq: eq,
            compare: compare
          },
          $$Set: $$Set,
          $$Map: $$Map
        };
}

function MakeOpaqueIntType($star) {
  var fromInt = function (param) {
    return Relude_Globals.$great$great(Relude_Globals.id, Relude_Option.pure, param);
  };
  var partial_arg = Curry._1(Relude_Option.flatMap, fromInt);
  var fromString = function (param) {
    return Relude_Globals.$great$great(Relude_String.toInt, partial_arg, param);
  };
  var toString = function (param) {
    return Relude_Globals.$great$great(Relude_Globals.id, Relude_Int.toString, param);
  };
  var decode = function (json) {
    return Curry._2(Json.Decode.$less$pipe$great, Curry._2(Json.Decode.variantFromInt, fromInt, json), Curry._2(Json.Decode.variantFromString, fromString, json));
  };
  var encode = function (param) {
    return Relude_Globals.$great$great(Relude_Globals.id, (function (prim) {
                  return prim;
                }), param);
  };
  var compare = Curry._1(Relude_Int.compareWithConversion, Relude_Globals.id);
  var eq = Curry._1(Relude_Int.eqWithConversion, Relude_Globals.id);
  var $$Set = Relude_Set.WithOrd({
        eq: eq,
        compare: compare
      });
  var $$Map = Relude_Map.WithOrd({
        eq: eq,
        compare: compare
      });
  return {
          fromInt: fromInt,
          fromString: fromString,
          toInt: Relude_Globals.id,
          toString: toString,
          decode: decode,
          encode: encode,
          compare: compare,
          eq: eq,
          Ord: {
            eq: eq,
            compare: compare
          },
          $$Set: $$Set,
          $$Map: $$Map
        };
}

function MakeCustomOpaqueFloatType(O) {
  var fromFloat = O.fromFloat;
  var partial_arg = Curry._1(Relude_Option.flatMap, fromFloat);
  var fromString = function (param) {
    return Relude_Globals.$great$great(Relude_String.toFloat, partial_arg, param);
  };
  var toFloat = O.toFloat;
  var toString = function (param) {
    return Relude_Globals.$great$great(toFloat, Relude_Float.toString, param);
  };
  var decode = function (json) {
    return Curry._3(Json.Decode.variantFromJson, Json.Decode.floatFromNumberOrString, fromFloat, json);
  };
  var encode = function (param) {
    return Relude_Globals.$great$great(toFloat, (function (prim) {
                  return prim;
                }), param);
  };
  var compare = Curry._1(Relude_String.compareWithConversion, toString);
  var eq = Curry._1(Relude_String.eqWithConversion, toString);
  var $$Set = Relude_Set.WithOrd({
        eq: eq,
        compare: compare
      });
  var $$Map = Relude_Map.WithOrd({
        eq: eq,
        compare: compare
      });
  return {
          fromFloat: fromFloat,
          fromString: fromString,
          toFloat: toFloat,
          toString: toString,
          decode: decode,
          encode: encode,
          compare: compare,
          eq: eq,
          Ord: {
            eq: eq,
            compare: compare
          },
          $$Set: $$Set,
          $$Map: $$Map
        };
}

function MakeOpaqueFloatType($star) {
  var fromFloat = function (param) {
    return Relude_Globals.$great$great(Relude_Globals.id, Relude_Option.pure, param);
  };
  var partial_arg = Curry._1(Relude_Option.flatMap, fromFloat);
  var fromString = function (param) {
    return Relude_Globals.$great$great(Relude_String.toFloat, partial_arg, param);
  };
  var toString = function (param) {
    return Relude_Globals.$great$great(Relude_Globals.id, Relude_Float.toString, param);
  };
  var decode = function (json) {
    return Curry._3(Json.Decode.variantFromJson, Json.Decode.floatFromNumberOrString, fromFloat, json);
  };
  var encode = function (param) {
    return Relude_Globals.$great$great(Relude_Globals.id, (function (prim) {
                  return prim;
                }), param);
  };
  var compare = Curry._1(Relude_String.compareWithConversion, toString);
  var eq = Curry._1(Relude_String.eqWithConversion, toString);
  var $$Set = Relude_Set.WithOrd({
        eq: eq,
        compare: compare
      });
  var $$Map = Relude_Map.WithOrd({
        eq: eq,
        compare: compare
      });
  return {
          fromFloat: fromFloat,
          fromString: fromString,
          toFloat: Relude_Globals.id,
          toString: toString,
          decode: decode,
          encode: encode,
          compare: compare,
          eq: eq,
          Ord: {
            eq: eq,
            compare: compare
          },
          $$Set: $$Set,
          $$Map: $$Map
        };
}

function list(startingIndex, toEnum, _xs) {
  while(true) {
    var xs = _xs;
    if (!xs) {
      return Relude_Option.fold(/* [] */0, (function (param) {
                    return list(startingIndex, toEnum, {
                                hd: startingIndex,
                                tl: /* [] */0
                              });
                  }), Curry._1(toEnum, startingIndex));
    }
    var x = xs.hd;
    if (!Relude_Option.isSome(Curry._1(toEnum, x + 1 | 0))) {
      return xs;
    }
    _xs = {
      hd: x + 1 | 0,
      tl: xs
    };
    continue ;
  };
}

function list$1(startingIndex, toEnum) {
  return Relude_List.mapOption(toEnum, Relude_List.reverse(list(startingIndex, toEnum, /* [] */0)));
}

function WithGenerateable(G) {
  var eq = Curry._1(Relude_Int.eqWithConversion, G.fromEnum);
  var compare = Curry._1(Relude_Int.compareWithConversion, G.fromEnum);
  var Ord = {
    eq: eq,
    compare: compare
  };
  var include = Relude_Extensions_Ord.OrdExtensions(Ord);
  var $$Set = Relude_Set.WithOrd(Ord);
  var eq$1 = function (param, param$1) {
    return Relude_Option.eqBy(eq, param, param$1);
  };
  var compare$1 = function (param) {
    var a = param[0];
    if (a === undefined) {
      if (param[1] !== undefined) {
        return "less_than";
      } else {
        return "equal_to";
      }
    }
    var b = param[1];
    if (b !== undefined) {
      return Curry._2(compare, Caml_option.valFromOption(a), Caml_option.valFromOption(b));
    } else {
      return "greater_than";
    }
  };
  var compare$2 = function (param, param$1) {
    return Relude_Function.curry2(compare$1, param, param$1);
  };
  var include$1 = Relude_Set.WithOrd({
        eq: eq$1,
        compare: compare$2
      });
  var fromList = include$1.fromList;
  var partial_arg = Relude_List.map(Relude_Option.pure);
  var partial_arg$1 = function (param) {
    return Relude_Globals.$great$great($$Set.toList, partial_arg, param);
  };
  var fromSet = function (param) {
    return Relude_Globals.$great$great(partial_arg$1, fromList, param);
  };
  var SetWithNone_Comparable = include$1.Comparable;
  var SetWithNone_empty = include$1.empty;
  var SetWithNone_fromArray = include$1.fromArray;
  var SetWithNone_isEmpty = include$1.isEmpty;
  var SetWithNone_contains = include$1.contains;
  var SetWithNone_add = include$1.add;
  var SetWithNone_mergeMany = include$1.mergeMany;
  var SetWithNone_remove = include$1.remove;
  var SetWithNone_removeMany = include$1.removeMany;
  var SetWithNone_update = include$1.update;
  var SetWithNone_toggle = include$1.toggle;
  var SetWithNone_union = include$1.union;
  var SetWithNone_intersect = include$1.intersect;
  var SetWithNone_diff = include$1.diff;
  var SetWithNone_subset = include$1.subset;
  var SetWithNone_compare = include$1.compare;
  var SetWithNone_eq = include$1.eq;
  var SetWithNone_forEach = include$1.forEach;
  var SetWithNone_foldLeft = include$1.foldLeft;
  var SetWithNone_foldRight = include$1.foldRight;
  var SetWithNone_all = include$1.all;
  var SetWithNone_any = include$1.any;
  var SetWithNone_filter = include$1.filter;
  var SetWithNone_keep = include$1.keep;
  var SetWithNone_filterNot = include$1.filterNot;
  var SetWithNone_reject = include$1.reject;
  var SetWithNone_partition = include$1.partition;
  var SetWithNone_length = include$1.length;
  var SetWithNone_toArray = include$1.toArray;
  var SetWithNone_toList = include$1.toList;
  var SetWithNone_minimum = include$1.minimum;
  var SetWithNone_maximum = include$1.maximum;
  var SetWithNone_get = include$1.get;
  var SetWithNone_getOrElse = include$1.getOrElse;
  var SetWithNone_split = include$1.split;
  var SetWithNone = {
    Comparable: SetWithNone_Comparable,
    empty: SetWithNone_empty,
    fromArray: SetWithNone_fromArray,
    fromList: fromList,
    isEmpty: SetWithNone_isEmpty,
    contains: SetWithNone_contains,
    add: SetWithNone_add,
    mergeMany: SetWithNone_mergeMany,
    remove: SetWithNone_remove,
    removeMany: SetWithNone_removeMany,
    update: SetWithNone_update,
    toggle: SetWithNone_toggle,
    union: SetWithNone_union,
    intersect: SetWithNone_intersect,
    diff: SetWithNone_diff,
    subset: SetWithNone_subset,
    compare: SetWithNone_compare,
    eq: SetWithNone_eq,
    forEach: SetWithNone_forEach,
    foldLeft: SetWithNone_foldLeft,
    foldRight: SetWithNone_foldRight,
    all: SetWithNone_all,
    any: SetWithNone_any,
    filter: SetWithNone_filter,
    keep: SetWithNone_keep,
    filterNot: SetWithNone_filterNot,
    reject: SetWithNone_reject,
    partition: SetWithNone_partition,
    length: SetWithNone_length,
    toArray: SetWithNone_toArray,
    toList: SetWithNone_toList,
    minimum: SetWithNone_minimum,
    maximum: SetWithNone_maximum,
    get: SetWithNone_get,
    getOrElse: SetWithNone_getOrElse,
    split: SetWithNone_split,
    fromSet: fromSet
  };
  var $$Map = Relude_Map.WithOrd(Ord);
  var list$2 = list$1(G.startingIndex, G.toEnum);
  var array = Relude_List.toArray(list$2);
  var set = Curry._1($$Set.fromList, list$2);
  var setWithNone = Curry._1(fromList, Relude_List.prepend(undefined, Relude_List.map(Relude_Option.pure)(list$2)));
  var cardinality = Curry._1(Relude_List.length, list$2);
  var bottom = Relude_Option.getOrThrow(Relude_List.head(list$2));
  var top = Relude_Option.getOrThrow(Relude_List.last(list$2));
  var succ = function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Globals.$great$great(G.fromEnum, (function (param) {
                                return Relude_Int.add(1, param);
                              }), param);
                }), G.toEnum, param);
  };
  var pred = function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Globals.$great$great(G.fromEnum, (function (__x) {
                                return Relude_Int.subtract(__x, 1);
                              }), param);
                }), G.toEnum, param);
  };
  return {
          fromEnum: G.fromEnum,
          toEnum: G.toEnum,
          eq: eq,
          compare: compare,
          Ord: Ord,
          compareWithConversion: include.compareWithConversion,
          compareReversed: include.compareReversed,
          OrdReversed: include.OrdReversed,
          compareAsInt: include.compareAsInt,
          min: include.min,
          max: include.max,
          lessThan: include.lessThan,
          lt: include.lt,
          lessThanOrEq: include.lessThanOrEq,
          lte: include.lte,
          greaterThan: include.greaterThan,
          gt: include.gt,
          greaterThanOrEq: include.greaterThanOrEq,
          gte: include.gte,
          clamp: include.clamp,
          between: include.between,
          OrdRingExtensions: include.OrdRingExtensions,
          OrdNamed: include.OrdNamed,
          OrdBy: include.OrdBy,
          $$Set: $$Set,
          SetWithNone: SetWithNone,
          $$Map: $$Map,
          list: list$2,
          array: array,
          set: set,
          setWithNone: setWithNone,
          cardinality: cardinality,
          top: top,
          bottom: bottom,
          succ: succ,
          pred: pred
        };
}

var TypeClasses = {
  list: list$1,
  WithGenerateable: WithGenerateable
};

var ensureList = Relude_List.foldLeft((function (param, param$1) {
        
      }), undefined);

exports.MakeCustomOpaqueStringType = MakeCustomOpaqueStringType;
exports.MakeOpaqueStringType = MakeOpaqueStringType;
exports.MakeCustomOpaqueIntType = MakeCustomOpaqueIntType;
exports.MakeOpaqueIntType = MakeOpaqueIntType;
exports.MakeCustomOpaqueFloatType = MakeCustomOpaqueFloatType;
exports.MakeOpaqueFloatType = MakeOpaqueFloatType;
exports.TypeClasses = TypeClasses;
exports.ensureList = ensureList;
/* ensureList Not a pure module */
